import React from 'react';

import { Center, Stack, Text } from '@mantine/core';
import { IconCalendarOff } from '@tabler/icons-react';

import AssignWorkoutSlot from './cards/AssignWorkoutSlot';
import DayCard from './cards/DayCard';
import type { AthleteCalendarItem, AthleteCalendarWorkoutItem } from './types';

interface AthleteDayViewProps {
  date: string;
  itemsByDate: Map<string, AthleteCalendarItem[]>;
  onItemClick: (item: AthleteCalendarItem, date: string) => void;
  onAssignWorkout: (date: string) => void;
  canAssign: boolean;
  renderWorkoutMenu?: (item: AthleteCalendarWorkoutItem, date: string) => React.ReactNode;
}

const AthleteDayView = ({
  date,
  itemsByDate,
  onItemClick,
  onAssignWorkout,
  canAssign,
  renderWorkoutMenu,
}: AthleteDayViewProps): JSX.Element => {
  const items = itemsByDate.get(date) ?? [];

  return (
    <Stack spacing='xs' p='sm' data-cy='athleteDayStack'>
      {items.length === 0 ? (
        <Center mih={200} data-cy='athleteDayEmpty'>
          <Stack align='center' spacing={4} c='gray.5'>
            <IconCalendarOff size={28} stroke={1.5} />
            <Text size='sm'>Nothing scheduled</Text>
          </Stack>
        </Center>
      ) : (
        items.map(item => (
          <DayCard
            key={`${item.kind}-${item.id}`}
            item={item}
            onClick={clicked => onItemClick(clicked, date)}
            menu={item.kind === 'workout' ? renderWorkoutMenu?.(item, date) : undefined}
          />
        ))
      )}

      {canAssign && <AssignWorkoutSlot onClick={() => onAssignWorkout(date)} />}
    </Stack>
  );
};

export default AthleteDayView;
